(function () {
  // Houdt de fles en de losse "Gravure toevoegen"-addon in de winkelmand in
  // sync. De gravuregegevens (tekst/oriëntatie/positie/lettertype uit
  // blocks/engraving.liquid) staan als line item properties op de fles zelf,
  // los van de addon-regel die de meerprijs vertegenwoordigt. Zodra de addon
  // volledig uit de winkelmand verdwijnt, is er niemand meer die voor een
  // gravure betaalt, dus vegen we de gravureproperties van alle flessen
  // weg zodat alleen de kale fles overblijft.
  var CART_UPDATE_EVENT = 'cart:update';
  var CLEANUP_SOURCE = 'engraving-cleanup';
  var ADDON_HANDLE = 'gravure-toevoegen-2';
  var GRAVURE_PROPERTY_KEYS = [
    'Gravure tekst',
    'Gravure oriëntatie',
    'Gravure positie',
    'Gravure lettertype',
  ];
  var cleaning = false;

  function hasGravureProperties(properties) {
    if (!properties) return false;
    return GRAVURE_PROPERTY_KEYS.some(function (key) {
      return !!properties[key];
    });
  }

  function withoutGravureProperties(properties) {
    // /cart/change.js negeert een properties-object dat na het filteren
    // volledig leeg is (`{}`) — de regel blijft dan gewoon ongewijzigd
    // staan. Daarom de gravuresleutels op een lege string zetten in
    // plaats van ze weg te laten: altijd een niet-leeg object, en een
    // lege waarde wordt door cart-products.liquid (`property.last !=
    // blank`) sowieso niet getoond.
    var cleaned = {};
    Object.keys(properties || {}).forEach(function (key) {
      cleaned[key] = GRAVURE_PROPERTY_KEYS.indexOf(key) === -1 ? properties[key] : '';
    });
    return cleaned;
  }

  function sectionIdsInUse() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map(function (el) {
        return el.dataset.sectionId;
      })
      .filter(Boolean);
  }

  function changeLine(line, properties, sections) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, properties: properties, sections: sections.join(',') }),
    }).then(function (response) {
      return response.json();
    });
  }

  function cleanOrphanedEngravings() {
    if (cleaning) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var addonStillInCart = cart.items.some(function (item) {
          return item.handle === ADDON_HANDLE;
        });
        if (addonStillInCart) return;

        var linesToClean = cart.items.reduce(function (lines, item, index) {
          if (hasGravureProperties(item.properties)) {
            lines.push({ line: index + 1, properties: withoutGravureProperties(item.properties) });
          }
          return lines;
        }, []);
        if (linesToClean.length === 0) return;

        cleaning = true;
        var sections = sectionIdsInUse();
        var lastResult = null;

        return linesToClean
          .reduce(function (chain, lineUpdate) {
            return chain.then(function () {
              return changeLine(lineUpdate.line, lineUpdate.properties, sections).then(function (result) {
                lastResult = result;
              });
            });
          }, Promise.resolve())
          .then(function () {
            if (!lastResult) return;
            document.dispatchEvent(
              new CustomEvent(CART_UPDATE_EVENT, {
                bubbles: true,
                detail: {
                  resource: lastResult,
                  sourceId: CLEANUP_SOURCE,
                  data: { source: CLEANUP_SOURCE, sections: lastResult.sections },
                },
              })
            );
          });
      })
      .catch(function (error) {
        console.error('Gravure-opruiming van de winkelmand is mislukt:', error);
      })
      .finally(function () {
        cleaning = false;
      });
  }

  document.addEventListener(CART_UPDATE_EVENT, function (event) {
    var data = (event.detail && event.detail.data) || {};
    // "cart:update" dekt zowel een fles toevoegen (source
    // 'product-form-component') als een regel wijzigen/verwijderen in de
    // winkelmand zelf (source 'cart-items-component'). Alleen op die
    // laatste reageren: anders rent dit opruimscript, bij het toevoegen
    // van een fles + gravure, de addon-aanvraag van engraving-configurator.js
    // voorbij — de addon staat dan nog niet in de cart, dus leest dit
    // script dat verkeerd als "addon verwijderd" en veegt het de net
    // ingevulde gravuregegevens meteen weer weg.
    if (data.source !== 'cart-items-component') return;
    cleanOrphanedEngravings();
  });
})();
